import {useFilterManagement} from '../../../store/hooks/useFilterManagement'
import {useStatesAndHealthConditions} from '../../../store/hooks/breadCrumbs'
import {getState} from '../../../shared/helpers/getState'
import {usePersona} from '../../../store/hooks/persona'

export function useGetFiltersDataMap() {
  const {getQueryParams, getOutreachParams} = useFilterManagement()
  const {filters} = useStatesAndHealthConditions()
  const {personas, personasToggle} = usePersona()

  const appliedFilterParams = getQueryParams()
  const selectedState = getState(filters)
  const selectedPersonas = personasToggle ? {persona: personas} : {}

  // Get outreach params (benefits only for now)
  const outreach = getOutreachParams()
  const benefitsData = outreach.type === 'benefits' ? outreach.data : []

  const filtersDataMap = {
    ...appliedFilterParams,
    ...selectedPersonas,
    state: selectedState
  }
  return {filtersDataMap, benefitsData}
}
